import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { refreshPermissions } from "../redux/actions/userActions";

export const useRefreshPermissions = () => {
  const dispatch = useDispatch();
  const user = useSelector((state: any) => state.user);

  useEffect(() => {
    let isMounted = true;

    // Always refresh permissions for STAFF and MO users on app load
    // This ensures they have the latest permission settings after page refresh
    // or if admin updated permissions after they logged in
    const refreshPermissionsIfNeeded = async () => {
      if (user && user._id && (user.role === "STAFF" || user.role === "MO")) {
        console.log(`Refreshing permissions for ${user.role} user...`);
        // Execute the thunk manually
        const thunk = refreshPermissions();
        const promise = thunk(dispatch, () => ({ user }));
        if (isMounted) {
          await promise;
        }
      }
    };

    refreshPermissionsIfNeeded();

    // Cleanup function to prevent state updates on unmounted component
    return () => {
      isMounted = false;
    };
  }, [dispatch, user._id, user.role]); // Run when user._id or role changes
};
